import {
  RESET_CREATE_TICKET,
  CREATE_TICKET_NOTE,
  CREATE_TICKET_NOTE_COMPLETE,
  CREATE_TICKET_NOTE_ERROR,
  DOWNLOAD_TICKET_ATTACHMENT,
  DOWNLOAD_TICKET_ATTACHMENT_COMPLETE,
  GET_TICKET_ATTACHMENT_INFO,
  GET_TICKET_ATTACHMENT_INFO_COMPLETE,
  GET_TICKET_ATTACHMENT_INFO_ERROR,
  RESET_TICKET_NOTE_SUBMITTED,
} from "../actions/ticketActions";

interface TicketList {
  tickets: unknown[];
  lastTicketId?: number;
  lastTicketNumber?: string;
  [key: string]: unknown;
}

interface TicketState {
  ticket: unknown;
  tickets: TicketList;
  fetchingTicket: boolean;
  fetchTicketComplete: boolean;
  fetchTicketError: unknown;
  fetchingTickets: boolean;
  fetchTicketsComplete: boolean;
  fetchTicketsError: unknown;
  submittingTicket: boolean;
  ticketSubmitted: boolean;
  ticketSubmissionError: unknown;
  submittingTicketNote: boolean;
  ticketNoteSubmitted: boolean;
  ticketNoteSubmissionError: unknown;
  fetchingFile: Record<string, boolean>;
  fetchFileComplete: Record<string, boolean>;
  fetchFileError: Record<string, unknown>;
  ticketAttachmentInfoContent: Record<string, unknown>;
  fetchingTicketAttachmentInfo: Record<string, boolean>;
  fetchTicketAttachmentInfoComplete: Record<string, boolean>;
  fetchTicketAttachmentInfoError: Record<string, unknown>;
}

interface TicketAction {
  type: string;
  payload: {
    data?: unknown;
  };
}

const updateTicketList = (existingTickets: TicketList, newPayload: TicketList): TicketList => {
  return {
    ...newPayload,
    lastTicketId:
      newPayload.lastTicketId !== undefined && newPayload.lastTicketId !== 0
        ? newPayload.lastTicketId
        : existingTickets.lastTicketId,
    lastTicketNumber:
      newPayload.lastTicketNumber !== undefined
        ? newPayload.lastTicketNumber
        : existingTickets.lastTicketNumber,
  };
};

export function ticketReducer(
  state: TicketState = {
    ticket: undefined,
    tickets: {
      tickets: [],
    },
    fetchingTicket: false,
    fetchTicketComplete: false,
    fetchTicketError: undefined,
    fetchingTickets: false,
    fetchTicketsComplete: false,
    fetchTicketsError: undefined,
    submittingTicket: false,
    ticketSubmitted: false,
    ticketSubmissionError: undefined,
    submittingTicketNote: false,
    ticketNoteSubmitted: false,
    ticketNoteSubmissionError: undefined,
    fetchingFile: {},
    fetchFileComplete: {},
    fetchFileError: {},
    ticketAttachmentInfoContent: {},
    fetchingTicketAttachmentInfo: {},
    fetchTicketAttachmentInfoComplete: {},
    fetchTicketAttachmentInfoError: {},
  },
  action: TicketAction
) {
  switch (action.type) {
    case RESET_TICKET_NOTE_SUBMITTED: {
      return Object.assign({}, state, {
        ticketNoteSubmitted: false,
      });
    }
    case GET_TICKET_ATTACHMENT_INFO: {
      const attachmentId = action.payload.data as string;
      return Object.assign({}, state, {
        fetchingTicketAttachmentInfo: {
          ...state.fetchingTicketAttachmentInfo,
          [attachmentId]: true,
        },
        fetchTicketAttachmentInfoComplete: {
          ...state.fetchTicketAttachmentInfoComplete,
          [attachmentId]: false,
        },
        fetchTicketAttachmentInfoError: {
          ...state.fetchTicketAttachmentInfoError,
          [attachmentId]: undefined,
        },
      });
    }
    case GET_TICKET_ATTACHMENT_INFO_COMPLETE: {
      const info = action.payload.data as { Id: string; Content: unknown };
      return Object.assign({}, state, {
        ticketAttachmentInfoContent: {
          ...state.ticketAttachmentInfoContent,
          [info.Id]: info.Content,
        },
        fetchingTicketAttachmentInfo: {
          ...state.fetchingTicketAttachmentInfo,
          [info.Id]: false,
        },
        fetchTicketAttachmentInfoComplete: {
          ...state.fetchTicketAttachmentInfoComplete,
          [info.Id]: true,
        },
        fetchTicketAttachmentInfoError: {
          ...state.fetchTicketAttachmentInfoError,
          [info.Id]: undefined,
        },
      });
    }
    case GET_TICKET_ATTACHMENT_INFO_ERROR: {
      const errorId = action.payload.data as string;
      return Object.assign({}, state, {
        fetchingTicketAttachmentInfo: {
          ...state.fetchingTicketAttachmentInfo,
          [errorId]: false,
        },
        fetchTicketAttachmentInfoComplete: {
          ...state.fetchTicketAttachmentInfoComplete,
          [errorId]: true,
        },
        fetchTicketAttachmentInfoError: {
          ...state.fetchTicketAttachmentInfoError,
          [errorId]: undefined,
        },
      });
    }
    case DOWNLOAD_TICKET_ATTACHMENT: {
      const downloadId = action.payload.data as string;
      return Object.assign({}, state, {
        fetchingFile: {
          ...state.fetchingFile,
          [downloadId]: true,
        },
        fetchFileComplete: {
          ...state.fetchFileComplete,
          [downloadId]: false,
        },
        fetchFileError: {
          ...state.fetchFileError,
          [downloadId]: undefined,
        },
      });
    }
    case DOWNLOAD_TICKET_ATTACHMENT_COMPLETE: {
      const downloadCompleteId = action.payload.data as string;
      return Object.assign({}, state, {
        fetchingFile: {
          ...state.fetchingFile,
          [downloadCompleteId]: false,
        },
        fetchFileComplete: {
          ...state.fetchFileComplete,
          [downloadCompleteId]: true,
        },
        fetchFileError: {
          ...state.fetchFileError,
          [downloadCompleteId]: undefined,
        },
      });
    }
    case RESET_CREATE_TICKET: {
      return Object.assign({}, state, {
        ticketSubmitted: false,
        submittingTicket: false,
        ticketSubmissionError: undefined,
      });
    }
    case CREATE_TICKET_NOTE: {
      return Object.assign({}, state, {
        ticketNoteSubmitted: false,
        submittingTicketNote: true,
      });
    }
    case CREATE_TICKET_NOTE_COMPLETE: {
      return Object.assign({}, state, {
        ticketNoteSubmitted: true,
        submittingTicketNote: false,
        tickets: updateTicketList(state.tickets, action.payload.data as TicketList),
      });
    }
    case CREATE_TICKET_NOTE_ERROR: {
      return Object.assign({}, state, {
        ticketNoteSubmitted: false,
        submittingTicketNote: false,
        ticketNoteSubmissionError: action.payload.data,
      });
    }
    default:
      return state;
  }
}
